import PageCommands from "../../../modules/app/layout/PageCommands";
import React from "react";

export default function ListingAccuracyPageCommands ({
  exportProviders,
  exportLocations
}) {
  return <PageCommands>
    <PageCommands>
      <div className="d-flex justify-content-end">
        <div className="dropdown">
          <button
            className="btn btn-outline-secondary"
            data-toggle="dropdown"
          >
            <i className="fas fa-cloud-download"/> Download
          </button>
          <ul className="dropdown-menu">
            <li onClick={exportProviders} className="dropdown-item">Providers</li>
            <li onClick={exportLocations} className="dropdown-item">Locations</li>
          </ul>
        </div>
      </div>
    </PageCommands>
  </PageCommands>
}
